import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=2c605a86&scoped=true"
import script from "./Distributor.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Distributor.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./Distributor.vue?vue&type=style&index=0&id=2c605a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c605a86",
  null
  
)

export default component.exports